<template>
  <b-container class="page-container" style="background-color: #f0f0f0" fluid>
    <ChallengeOfferCheckout :combos="combos" :variant="variant" />
  </b-container>
</template>
<style>
</style>

<script>
import ChallengeOfferCheckout from "@/components/checkout/challengeoffer/ChallengeOfferCheckout.vue";

export default {
  title: "SMART Blending Program",
  name: "SmartBlending",
  props: ["combos"],
  mounted: function() {
    let optimize = document.createElement("script");
    optimize.setAttribute("src",  "https://www.googleoptimize.com/optimize.js?id=OPT-WDWCDZ9");
    document.head.appendChild(optimize);
  },
  computed: {
    variant: function () {
      return 'C';
    },
  },
  components: {
    ChallengeOfferCheckout,
  },
};
</script>
